import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import UnderConstruction from '../components/common/construction/UnderConstruction';
import './styles.css';

const Home       = lazy(() => import('./pages/Home'));
const Works      = lazy(() => import('./pages/Works'));
const WorkDetail = lazy(() => import('./pages/WorkDetail'));
const About      = lazy(() => import('./pages/About'));
const Services   = lazy(() => import('./pages/Services'));
const Contact    = lazy(() => import('./pages/Contact'));
const Proposal   = lazy(() => import('./pages/Proposal'));

const Loader = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '60vh',
    color: '#AAAAAA',
    fontFamily: "'Inter', sans-serif",
    fontSize: 13,
    letterSpacing: '0.06em',
  }}>
    Loading…
  </div>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Pages where the header/footer should NOT render (full-screen takeover)
const BARE_ROUTES = ['/'];

const AppInner = () => {
  const { pathname } = useLocation();
  const isBare = BARE_ROUTES.includes(pathname);

  return (
    <>
      <ScrollToTop />
      {!isBare && <Header />}
      <main>
        <Suspense fallback={<Loader />}>
          <Switch>
            <Route exact path="/"         component={UnderConstruction} />
            <Route exact path="/home"     component={Home}       />
            <Route exact path="/works"    component={Works}      />
            <Route exact path="/about"    component={About}      />
            <Route exact path="/services" component={Services}   />
            <Route exact path="/contact"  component={Contact}    />
            <Route exact path="/proposal" component={Proposal}   />
            <Route path="/work/:slug"     component={WorkDetail} />
          </Switch>
        </Suspense>
      </main>
      {!isBare && <Footer />}
    </>
  );
};

const App = () => (
  <Router>
    <AppInner />
  </Router>
);

export default App;
